
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Bookpunetomahabaleshwercab() {



    const cardData =
    {
        keyword: 'Pune to Mahabaleshwar Taxi Services',
        heading: 'S9 Travels: Pune to Mahabaleshwar Taxi Services',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable taxi services from Pune to Mahabaleshwar. Whether you are planning a peaceful getaway, exploring scenic viewpoints, or enjoying the cool climate, our well-maintained fleet and professional drivers ensure a smooth and hassle-free journey. Mahabaleshwar is approximately 120 km from Pune, and the journey takes around 3 to 3.5 hours by road. Enjoy a safe and comfortable ride with our top-notch amenities and customer-centric service.',

        top: 'Top Places to Visit in Mahabaleshwar with S9 Travels',

        "topPlaces": [
            {
              "title": "Mahabaleshwar Temple",
              "description": "One of the most revered temples in the region, the Mahabaleshwar Temple is dedicated to Lord Shiva. This ancient temple, with its impressive architecture and spiritual ambiance, attracts devotees and history enthusiasts alike. The temple is a significant landmark and a must-visit for those seeking peace and tranquility."
            },
            {
              "title": "Venna Lake",
              "description": "Venna Lake is a popular spot for boating and picnics. Surrounded by lush greenery, the lake offers a relaxing experience with options for pedal boating, row boating, and horse riding. It is one of the best places to unwind and enjoy the scenic beauty of Mahabaleshwar."
            },
            {
              "title": "Pratapgad Fort",
              "description": "Situated around 24 km from Mahabaleshwar, Pratapgad Fort is a historic fort with stunning views of the Sahyadri mountain range. Built by Chhatrapati Shivaji Maharaj, the fort has historical significance and offers a fascinating glimpse into Maratha history. The trek to the fort is both adventurous and rewarding."
            },
            {
              "title": "Elephant's Head Point",
              "description": "One of the most famous viewpoints in Mahabaleshwar, Elephant's Head Point offers breathtaking panoramic views of the surrounding valleys and hills. The viewpoint is named after a rock formation that resembles an elephant's head. It is an ideal spot for nature lovers and photographers."
            },
            {
              "title": "Arthur's Seat",
              "description": "Arthur's Seat is a famous vantage point that offers a stunning view of the deep valleys and the picturesque landscapes of Mahabaleshwar. Often referred to as the 'Queen of all Points,' it’s a great spot to enjoy the tranquility and beauty of the region."
            },
            {
              "title": "Mapro Garden",
              "description": "Mapro Garden is a delightful stop for those looking to enjoy fresh strawberries and other fruit-based products. It’s a popular spot for families and foodies, with a café offering delicious food and beverages. The garden also features a shop where visitors can purchase jams, syrups, and other local products."
            },
            {
              "title": "Wilson Point",
              "description": "Wilson Point is the highest point in Mahabaleshwar, offering breathtaking 360-degree views of the surrounding valleys, forests, and hills. It is an excellent spot for witnessing a beautiful sunrise or sunset, making it a popular spot for photographers and nature enthusiasts."
            },
            {
              "title": "Lingmala Waterfall",
              "description": "Lingmala Waterfall is one of the most beautiful waterfalls in Mahabaleshwar. It is located around 6 km from the main town and offers a refreshing escape into nature. The waterfall is surrounded by lush greenery, and the sight of the water cascading down the rocky terrain is mesmerizing."
            },
            {
              "title": "Strawberry Farms",
              "description": "Mahabaleshwar is known for its strawberry cultivation, and visiting the strawberry farms is a unique experience. Visitors can pick fresh strawberries and enjoy the beautiful green fields. The farms are typically open from November to March."
            },
            {
              "title": "Babington Point",
              "description": "Babington Point is another scenic viewpoint that offers panoramic views of the valleys and hills surrounding Mahabaleshwar. It is a quieter spot compared to other viewpoints and is perfect for those looking for peace and solitude in the midst of nature."
            }
          ],

"services": [
  {
    "name": "Pune to Mahabaleshwar Taxi",
    "description": "S9 Travels offers comfortable and reliable taxi services for your journey from Pune to Mahabaleshwar. Whether you’re visiting for a weekend getaway, a nature retreat, or to explore the hill station, enjoy a smooth and hassle-free ride. Book your Pune to Mahabaleshwar taxi today!"
  },
  {
    "name": "Pune to Mahabaleshwar Cab Booking",
    "description": "Booking a cab from Pune to Mahabaleshwar is simple with S9 Travels. Whether you prefer to book online or by phone, we provide flexible booking options to suit your needs. Book your ride today for a hassle-free journey!"
  },
  {
    "name": "Pune to Mahabaleshwar Taxi Service",
    "description": "Choose S9 Travels for a professional and reliable taxi service from Pune to Mahabaleshwar. Our experienced drivers and well-maintained vehicles guarantee a safe, comfortable, and enjoyable journey."
  },
  {
    "name": "Pune to Mahabaleshwar One-Way Taxi",
    "description": "S9 Travels provides affordable one-way taxi services for your journey from Pune to Mahabaleshwar. Travel directly to your destination with ease and comfort. Book your one-way taxi today for a stress-free experience."
  },
  {
    "name": "Pune to Mahabaleshwar Round Trip",
    "description": "For a round trip from Pune to Mahabaleshwar, S9 Travels offers flexible and reliable options. We ensure that your journey is smooth, timely, and enjoyable, with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Pune to Mahabaleshwar Cab Fare",
    "description": "S9 Travels provides transparent and affordable cab fares for your Pune to Mahabaleshwar journey. We guarantee you get the best value for your money, with no hidden charges. Contact us for an accurate fare estimate before booking."
  },
  {
    "name": "Pune to Mahabaleshwar Car Rental",
    "description": "Looking to rent a car for your trip from Pune to Mahabaleshwar? S9 Travels offers flexible car rental services, allowing you to travel at your own pace. Choose from a variety of vehicles that best suit your travel needs."
  },
  {
    "name": "Pune to Mahabaleshwar Luxury Taxi",
    "description": "For a luxurious travel experience, S9 Travels offers premium luxury taxi services from Pune to Mahabaleshwar. Enjoy a smooth and stylish ride with extra space, enhanced comfort, and a relaxing journey in our high-end vehicles."
  },
  {
    "name": "Pune to Mahabaleshwar Efficient Taxi",
    "description": "S9 Travels provides Efficient Taxi services for a budget-friendly travel option. Share the ride with others and enjoy a comfortable, convenient journey from Pune to Mahabaleshwar at an affordable price."
  }
],


"tableData": [
  ["Book Pune To Mahabaleshwar Taxi", "Book Pune To Mahabaleshwar Cab Booking"],
  ["Book Pune To Mahabaleshwar Taxi Service", "Book Pune To Mahabaleshwar One-Way Taxi"],
  ["Book Pune To Mahabaleshwar Round Trip", "Book Pune To Mahabaleshwar Cab Fare"],
  ["Book Pune To Mahabaleshwar Car Rental", "Book Pune To Mahabaleshwar Luxury Taxi"],
  ["Book Pune To Mahabaleshwar Efficient Taxi", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we know how important your time is when traveling from Pune to Mahabaleshwar. Whether it's for a relaxing holiday or a weekend getaway, our drivers ensure prompt pickups and drop-offs, making your trip smooth and hassle-free."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a variety of well-maintained vehicles for your journey to Mahabaleshwar. Our fleet includes comfortable cars with air conditioning, spacious seating, and ample luggage space to ensure a relaxing travel experience."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced and familiar with the best routes to Mahabaleshwar. They ensure a smooth, safe, and enjoyable journey, providing friendly service and expert driving throughout the trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable and transparent pricing for your Pune to Mahabaleshwar trip. There are no hidden fees; we provide a clear breakdown of costs upfront, so you know exactly what to expect."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features, including airbags, seat belts, and GPS tracking, ensuring a secure and comfortable journey to Mahabaleshwar."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels is available 24/7. Whether you want an early morning departure or a late-night return, we are always ready to serve your needs. Our customer service team is available around the clock for assistance."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a Pune to Mahabaleshwar cab is simple with S9 Travels. You can book through our website, mobile app, or by calling our customer service team for personalized assistance."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages for your visit to Mahabaleshwar, whether it’s for a peaceful retreat, sightseeing, or a family vacation. Let us know your preferences, and we’ll tailor the trip to make it memorable."
  }
]


















    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Mahabaleshwar cab with S9 Travels?',
            answer: 'Booking is easy! You can book online through our website or app, or contact our customer service team for assistance.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, all our drivers are experienced in long-distance travel and are familiar with the best routes to Mahabaleshwar. They ensure a safe and comfortable journey.',
          },
          {
            question: 'What types of vehicles are available for Pune to Mahabaleshwar travel?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and premium cars, all well-maintained for a comfortable and safe trip.',
          },
          {
            question: 'How do I pay for my Pune to Mahabaleshwar cab rental?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and online payments via our app for your convenience.',
          },
          {
            question: 'Can I book a round trip from Pune to Mahabaleshwar?',
            answer: 'Yes, we offer round-trip services. Simply provide your return details, and we will take care of the rest for a seamless journey.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges, such as waiting time or detours, will be communicated to you upfront, ensuring transparency in our pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Mahabaleshwar?',
            answer: 'Yes, we offer sightseeing tours in Mahabaleshwar. Explore famous spots like Venna Lake, Pratapgarh Fort, Mapro Garden, and more with our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Mahabaleshwar cab?',
            answer: 'Our vehicles comfortably accommodate standard luggage. If you have extra luggage or specific requirements, please let us know during the booking process, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel between Pune and Mahabaleshwar?',
            answer: 'Yes, we offer corporate travel services, including group trips or business-related visits, between Pune and Mahabaleshwar.',
          },
          {
            question: 'Why should I choose S9 Travels for Pune to Mahabaleshwar travel?',
            answer: 'S9 Travels ensures a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. You can count on us for a smooth, stress-free trip to Mahabaleshwar every time.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Ajay Yadav',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“We had a wonderful trip to Mahabaleshwar with S9 Travels. The driver was punctual, the car was comfortable, and the whole experience was smooth. We highly recommend S9 Travels for anyone planning a trip to Mahabaleshwar!”',
        },
        {
          name: 'Mrs. Anita Shah',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family trip to Mahabaleshwar was fantastic thanks to S9 Travels. The vehicle was spacious and clean, and the driver was knowledgeable about the area. We had a great time, and we’ll definitely book again for future trips!”',
        },
      ];
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Book Pune To Mahabaleshwar Cab",
        "description": "Book Pune To Mahabaleshwar taxi services, one-way taxi, round trip, luxury taxi, Efficient Taxi, and car rental with S9 Travels. Choose from affordable Pune to Mahabaleshwar cab booking options for a comfortable and scenic journey to Mahabaleshwar.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
      
      
      
      


    return (
        <div>
         <Helmet>
        <title>Book Pune To Mahabaleshwar Cab | Affordable Taxi & Car Rental Services | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune To Mahabaleshwar taxi services, one-way taxi, round trip, luxury taxi, Efficient Taxi, and car rental with S9 Travels. Get the best fares for Pune to Mahabaleshwar cab booking and enjoy a safe, comfortable, and scenic ride to Mahabaleshwar." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/13.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bookpunetomahabaleshwercab;